(() => {
  const script = document.querySelector('script[data-ndw-accessibility]');
  if (!script) return;
  const newsletterName = script.dataset.newsletterName;
  const brandName = script.dataset.brandName;
  const formSelector = '[data-forms-id="forms-root-847255"] shopify-forms-embed';
  const newsletterSelector = 'form[data-testid="klaviyo-form-RZXUTh"]';
  const teaserSelector = '[role="button"][class*="Teaser-pointer"]';
  const forms = new WeakSet();
  const popups = new WeakSet();

  const setAttribute = (element, name, value) => {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  };

  const repairForm = (root) => {
    root.querySelectorAll('textarea[name]').forEach((field) => {
      const label = field.parentElement?.querySelector('label[for]');
      if (!label || label.htmlFor !== field.name) return;
      if (!field.id && !root.getElementById(label.htmlFor)) field.id = label.htmlFor;
      if (field.id === label.htmlFor && label.id) {
        setAttribute(field, 'aria-labelledby', label.id);
      }
    });
    const container = root.querySelector('section[data-sizing="form-wrapper"]');
    const heading = container?.querySelector('h2');
    const form = container?.querySelector('form');
    if (!container || !heading || !form) return;
    if (!heading.id) heading.id = 'ndw-custom-form-title-847255';
    container.removeAttribute('role');
    container.removeAttribute('aria-modal');
    container.removeAttribute('aria-label');
    setAttribute(form, 'aria-labelledby', heading.id);
  };

  const connectForm = (host, attempt = 0) => {
    if (forms.has(host) || !host.isConnected) return;
    const root = host.shadowRoot;
    if (!root) {
      if (attempt < 40) setTimeout(() => connectForm(host, attempt + 1), 250);
      return;
    }
    forms.add(host);
    repairForm(root);
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      queueMicrotask(() => {
        queued = false;
        repairForm(root);
      });
    }).observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['id', 'for', 'role', 'aria-modal', 'aria-labelledby']
    });
  };

  const repairPopup = (form) => {
    const dialog = form.closest('[role="dialog"]');
    if (!dialog) return;
    setAttribute(dialog, 'aria-label', newsletterName);
    setAttribute(dialog, 'data-ndw-newsletter', '');
    if (dialog.firstElementChild) {
      setAttribute(dialog.firstElementChild, 'data-ndw-newsletter-frame', '');
    }
    form.querySelectorAll('img').forEach((image) => {
      if (image.src.includes('/SwLFtQ/images/d629ea68-9acf-48c9-a2c5-793237bc1ca5.png')) {
        setAttribute(image, 'alt', brandName);
      }
    });
    if (popups.has(dialog)) return;
    popups.add(dialog);
    new MutationObserver(() => {
      const current = dialog.querySelector(newsletterSelector);
      if (current) repairPopup(current);
    }).observe(dialog, { childList: true, subtree: true });
  };

  const enhance = (node) => {
    if (!(node instanceof Element)) return;
    if (node.matches(formSelector)) connectForm(node);
    node.querySelectorAll(formSelector).forEach((host) => connectForm(host));
    const form = node.matches(newsletterSelector) ? node : node.closest(newsletterSelector);
    if (form) repairPopup(form);
    node.querySelectorAll(newsletterSelector).forEach(repairPopup);
    const teasers = new Set(node.querySelectorAll(teaserSelector));
    const enclosingTeaser = node.closest(teaserSelector);
    if (enclosingTeaser) teasers.add(enclosingTeaser);
    teasers.forEach((teaser) => {
      if (teaser.querySelector('[id="rich-text-01KJ460E9AC7CRK5S3QV28ZJF8"]')) {
        setAttribute(teaser, 'aria-label', newsletterName);
      }
    });
  };

  enhance(document.body);
  new MutationObserver((records) => {
    records.forEach((record) => record.addedNodes.forEach(enhance));
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
    const tile = event.target instanceof Element
      ? event.target.closest('.instafeed-new-layout-item-container[role="button"][aria-haspopup="dialog"]')
      : null;
    if (!tile || event.target !== tile) return;
    const trigger = tile.querySelector('.instafeed-hover-layer[data-instafeed-open-id]');
    if (!trigger) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.repeat) return;
    trigger.click();
    requestAnimationFrame(() => {
      const popup = document.getElementById(trigger.dataset.instafeedOpenId);
      if (popup && getComputedStyle(popup).display !== 'none' && !popup.contains(document.activeElement)) {
        popup.querySelector('.instafeed-close-button')?.focus({ preventScroll: true });
      }
    });
  }, true);
})();
